// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 140 140%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpolygon points=%270,0 140,0 70,70%27 fill=%27%23EA6C22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* لیست محصولات و وندورها */
.vendors {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.vendor {
    background: #f9fafb;
    padding: 12px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e5e7eb;
}

.vendor span {
    /* اگر خواستی می‌توانی اینجا استایل دلخواه برای متن اضافه کنی */
}

.vendor .muted {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}


/* دکمه ویرایش محصول داخل وندورها */
.vendor .edit-product {
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 8px;
    border: none;
    background: var(--mainColor);
    color: #fff;
    cursor: pointer;
    margin-left: 8px;
    box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
}

.vendor .edit-product:hover {
    background-color: var(--mainColor);
}





.modal-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  background-color: #ececec;
  color: #000;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.confirm-btn {
  background: linear-gradient(90deg, #ff7a00, #ff4c00);
  color: #fff;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}


.delete-modal-title{
    text-align: center !important;
}


/* عنوان محصول راست چین و کوتاه شده */
.vendor .product-title {
    flex: 2 1;
    display: inline-block;
    max-width: 600px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
span.muted.product-extra-class {
    display: none;
}




/* 
.floating-label-group {
  position: relative;
  margin-bottom: 1.8rem;
  direction: rtl;
}

.floating-label-group input,
.floating-label-group select {
  width: 100%;
  padding: 0.8rem 0.5rem;
  border: 2px solid #ccc;
  border-radius: 8px;
  background: transparent;
  font-size: 16px;
  outline: none;
  text-align: right;
  appearance: none; 
  -webkit-appearance: none;
  -moz-appearance: none;
}

.floating-label-group input:focus,
.floating-label-group select:focus {
  border-color: #EA6C22;
}

/* placeholder خالی */
.floating-label-group input::placeholder,
.floating-label-group select::placeholder {
  color: transparent;
}

.floating-label-group input:placeholder-shown + label,
.floating-label-group select:placeholder-shown + label {
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #aaa;
  text-align: right;
}

.floating-label-group label {
  position: absolute;
  right: 0.5rem;
  top: 0;
  color: #EA6C22;
  font-size: 12px;
  pointer-events: none;
  transition: all 0.2s ease;
  text-align: right;
}

.floating-label-group input:focus + label,
.floating-label-group input:not(:placeholder-shown) + label,
.floating-label-group select:focus + label,
.floating-label-group select:not(:placeholder-shown) + label {
  top: -12px;
  font-size: 12px;
  color: #EA6C22;
}

.floating-label-group .error-text {
  display: block;
  margin-top: 0.3rem;
  color: red;
  font-size: 0.8rem;
  text-align: right;
}

.floating-label-group select {
  padding-left: 1.5rem; /* فضای داخلی برای فلش سمت چپ در RTL */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: left 0.5rem center;
  background-size: 0.6rem;
  cursor: pointer;
} */


.modal-form{
    margin-top: 20px;
}

.modal-title{
    margin-top: 30px;
    margin-bottom: 10px;
font-size: 24px;
}








`, "",{"version":3,"sources":["webpack://./src/components/Table/TableV2.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,+DAA+D;AACnE;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;;AAGA,mCAAmC;AACnC;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,kCAAkC;AACtC;;;;;;AAMA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;IACI,6BAA6B;AACjC;;;AAGA,qCAAqC;AACrC;IACI,SAAO;IACP,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,aAAa;AACjB;;;;;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;qBA2BqB;AACrB;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,MAAM;EACN,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;;EAIE,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB,EAAE,sCAAsC;EAC5D,yDAAgL;EAChL,4BAA4B;EAC5B,uCAAuC;EACvC,uBAAuB;EACvB,eAAe;AACjB,EAAE;;;;IAIE,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB,eAAe;AACf","sourcesContent":["/* لیست محصولات و وندورها */\n.vendors {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.vendor {\n    background: #f9fafb;\n    padding: 12px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid #e5e7eb;\n}\n\n.vendor span {\n    /* اگر خواستی می‌توانی اینجا استایل دلخواه برای متن اضافه کنی */\n}\n\n.vendor .muted {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 400px;\n}\n\n\n/* دکمه ویرایش محصول داخل وندورها */\n.vendor .edit-product {\n    padding: 4px 8px;\n    font-size: 12px;\n    border-radius: 8px;\n    border: none;\n    background: var(--mainColor);\n    color: #fff;\n    cursor: pointer;\n    margin-left: 8px;\n    box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);\n}\n\n.vendor .edit-product:hover {\n    background-color: var(--mainColor);\n}\n\n\n\n\n\n.modal-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  background-color: #ececec;\n  color: #000;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.confirm-btn {\n  background: linear-gradient(90deg, #ff7a00, #ff4c00);\n  color: #fff;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n\n.delete-modal-title{\n    text-align: center !important;\n}\n\n\n/* عنوان محصول راست چین و کوتاه شده */\n.vendor .product-title {\n    flex: 2;\n    display: inline-block;\n    max-width: 600px !important;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\nspan.muted.product-extra-class {\n    display: none;\n}\n\n\n\n\n/* \n.floating-label-group {\n  position: relative;\n  margin-bottom: 1.8rem;\n  direction: rtl;\n}\n\n.floating-label-group input,\n.floating-label-group select {\n  width: 100%;\n  padding: 0.8rem 0.5rem;\n  border: 2px solid #ccc;\n  border-radius: 8px;\n  background: transparent;\n  font-size: 16px;\n  outline: none;\n  text-align: right;\n  appearance: none; \n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.floating-label-group input:focus,\n.floating-label-group select:focus {\n  border-color: #EA6C22;\n}\n\n/* placeholder خالی */\n.floating-label-group input::placeholder,\n.floating-label-group select::placeholder {\n  color: transparent;\n}\n\n.floating-label-group input:placeholder-shown + label,\n.floating-label-group select:placeholder-shown + label {\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 16px;\n  color: #aaa;\n  text-align: right;\n}\n\n.floating-label-group label {\n  position: absolute;\n  right: 0.5rem;\n  top: 0;\n  color: #EA6C22;\n  font-size: 12px;\n  pointer-events: none;\n  transition: all 0.2s ease;\n  text-align: right;\n}\n\n.floating-label-group input:focus + label,\n.floating-label-group input:not(:placeholder-shown) + label,\n.floating-label-group select:focus + label,\n.floating-label-group select:not(:placeholder-shown) + label {\n  top: -12px;\n  font-size: 12px;\n  color: #EA6C22;\n}\n\n.floating-label-group .error-text {\n  display: block;\n  margin-top: 0.3rem;\n  color: red;\n  font-size: 0.8rem;\n  text-align: right;\n}\n\n.floating-label-group select {\n  padding-left: 1.5rem; /* فضای داخلی برای فلش سمت چپ در RTL */\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 140 140' xmlns='http://www.w3.org/2000/svg'%3E%3Cpolygon points='0,0 140,0 70,70' fill='%23EA6C22'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: left 0.5rem center;\n  background-size: 0.6rem;\n  cursor: pointer;\n} */\n\n\n.modal-form{\n    margin-top: 20px;\n}\n\n.modal-title{\n    margin-top: 30px;\n    margin-bottom: 10px;\nfont-size: 24px;\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
